import { useTranslation } from "react-i18next";
import { update } from "../_request";
import { useToast } from "../../modules/layout/components/ToastContext";
import { useState } from "react";
import { useNavigate } from "react-router-dom";


interface ResendActivationLinkProps{
    targetProfileId: string;
}

export enum NotificationPreference{
    EmailOnly = "EmailOnly",
    SmsOnly = "SmsOnly",
    EmailAndSms = "EmailAndSms"
}

export default function ResendActivationLink({targetProfileId}: ResendActivationLinkProps){
    const { t } = useTranslation();
    const { showToast } = useToast();
    const navigate = useNavigate();
    const[alreadyVerified, setAlreadyVerified] = useState(false);

    const[sendVia, setSendVia] = useState<NotificationPreference | "">("");
    const [loading, setLoading] = useState(false);

    const handleResend = async () =>{
        if (!targetProfileId) {
            showToast?.(t("Profile id is missing"), "error");
            return;
        }

        setLoading(true);

        try{
            const query = `?targetProfileId=${encodeURIComponent(targetProfileId)}` + ( sendVia ? `&sendVia=${sendVia}` : "");

            const result: any = await update(`/api/UserEvents/resendactivationlink${query}`, null);
            const respStatus = result?.response?.status || result?.status;

            if (respStatus === 200 || respStatus === undefined) {
                showToast && showToast(t("LinkSentSuccessfully"), "success")
            } else if (respStatus === 400) {
                showToast(t("LinkAlreadySent"), "info");
            } 
            else if (respStatus === 403){
                navigate ("/error/403");
            } else if ( respStatus === 401) {
                navigate ("/auth/login");
            } else if ( respStatus === 404) {
                showToast && showToast(t("ProfileNotFound"), "error");
            } else if (respStatus === 500){
                navigate("/error/500");
            } else { 
                showToast && showToast(t("StatusCode", { code: String(respStatus)}), "error");
            }
        } catch (error: any) {
            const message = error?.response?.data?.message ||
                            error?.response?.data?.error ||
                            error?.message;
            if (message?.includes("already verified")){
                setAlreadyVerified(true);
                showToast(t("UserAlreadyVerified"), "info");
            } else {
                showToast(t("SomethingWentWrong"), "error");
            }
        } finally {
            setLoading(false);
        }       
    }

    return(
            <div className="gg-profile-action">
                <h6 className="gg-profile-action__title"> 
                    {t("ResendActivationLink")}:
                </h6>

                <select className="form-select mb-2" 
                        value={sendVia}
                        onChange={(e) => setSendVia(e.target.value as NotificationPreference)}
                        disabled={loading}>
                            <option value="" disabled hidden>{t("SelectOption")}</option>
                            <option value={NotificationPreference.EmailOnly}> {t("EmailOnly")} </option>
                            <option value={NotificationPreference.EmailAndSms}> {t("EmailAndSms")} </option>
                            <option value={NotificationPreference.SmsOnly}> {t("SmsOnly")} </option>
                </select>

                <button className="btn btn-outline-primary w-100"
                        onClick={handleResend}
                        disabled={alreadyVerified||loading}>
                            {loading ? t("Sending") : t("ResendLink")}
                </button>
            </div>
        )

}